import { Box, makeStyles, CircularProgress } from "@material-ui/core";
import { usePopup } from "react-hook-popup";

function useSFLoading() {
  return usePopup("loading", () => {
    return <SFLoading />;
  });
}

const useStyles = makeStyles((theme) => ({
  background: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: "#424242dd",
    width: "100%",
    height: "100%",
    zIndex: 9990,
    display: "grid",
    placeItems: "center",
  },
  allContainer: {
    backgroundColor: theme.white,
    width: 200,
    height: 200,
    borderRadius: 12,
    position: "relative",
    display: "grid",
    placeItems: "center",
  },
}));
const SFLoading = () => {
  const classes = useStyles();
  return (
    <Box className={classes.background}>
      <Box className={classes.allContainer}>
        <CircularProgress />
      </Box>
    </Box>
  );
};

export default useSFLoading;
